import { isNative } from "../../native/utils"

type Navigate = (path: string, options?: { replace?: boolean }) => void

type RedirectOptions = {
  isInNativeWebView?: boolean
  replaceLocation?: (url: string) => void
}

/**
 * Inside the native WebView, land on the post-login route with a real page load.
 * Android only writes the new session cookie to disk when a page load finishes,
 * so a client-side route change here would lose the session when the app closes.
 */
export const redirectAfterLogin = (
  route: string,
  navigate: Navigate,
  options: RedirectOptions = {}
) => {
  const path = route.startsWith("/") ? route : `/${route}`
  const inNativeWebView = options.isInNativeWebView ?? isNative

  if (inNativeWebView) {
    const replaceLocation =
      options.replaceLocation ?? ((url: string) => window.location.replace(url))
    replaceLocation(path)
    return
  }

  navigate(path, { replace: true })
}
